import { Fragment, ReactElement, useMemo } from 'react';
import { CitizenshipNotificationsCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { CitizenshipNotificationsSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { CitizenshipNotificationsMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { CitizenshipNotificationsCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { CitizenshipNotificationsCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import ResearchCitizenshipNotificationsShared from '../../research-notifications/research-citizenship';

interface ResearchCitizenshipNotificationsCivilStatusSharedProps {
  scope?: string;
}

const ResearchCitizenshipNotificationsCivilStatusShared = ({
  scope,
}: ResearchCitizenshipNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/cittadinanza/ricerca/registrazione`;
  }, [goBackUrl]);

  const items = useMemo(() => {
    if (idCat) {
      return CitizenshipNotificationsCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return CitizenshipNotificationsCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return CitizenshipNotificationsSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return CitizenshipNotificationsMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return CitizenshipNotificationsCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <ResearchCitizenshipNotificationsShared
        redirectUrl={redirectUrl}
        goBackUrl={goBackUrl}
        items={items}
      />
    </Fragment>
  );
};

ResearchCitizenshipNotificationsCivilStatusShared.displayName =
  'Research Citizenship Notifications Page component';

export default ResearchCitizenshipNotificationsCivilStatusShared;
